import { atom } from "jotai";

export const intentTableRefetchAtom = atom<boolean>(false);
